import { useEffect, useMemo, useState } from "react";
import {
  USER_ROLE_FINANCE,
  USER_ROLE_SUPERAGENT,
  USER_ROLE_EMPLOYEE,
} from "../../common/constants";
import CustomDateSelector from "../../components/CustomDateSelector";
import AgentBillingDashboard from "./components/AgentBillingDashboard";
import { DateSwitcher } from "./components/DateSwitcher";
import { useSelector } from "react-redux";

const AgentBilling = () => {
  const [rangeDate, setRangeDate] = useState([]);
  const [durationSelect, setDurationSelect] = useState("");

  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (rangeDate?.[1] !== undefined) {
      setDurationSelect("Custom");
    }
  }, [rangeDate]);

  useEffect(() => {
    if (
      ![USER_ROLE_SUPERAGENT, USER_ROLE_FINANCE, USER_ROLE_EMPLOYEE].includes(
        user?.role
      )
    ) {
      window.location.href = "/booking";
    }
  }, [user?.role]);

  const { startDate, endDate } = DateSwitcher({
    durationSelect,
    rangeDate,
  });

  const query = useMemo(() => {
    return {
      startDate: startDate ? startDate?.toISOString() : "",
      endDate: endDate ? endDate?.toISOString() : "",
    };
  }, [startDate, endDate]);

  return (
    <div className="">
      <div className="md:mx-20">
        <CustomDateSelector
          rangeDate={rangeDate}
          setRangeDate={setRangeDate}
          setDurationSelect={setDurationSelect}
        />
      </div>
      <AgentBillingDashboard query={query} />
    </div>
  );
};

export default AgentBilling;
